// Staging Url
export const API_URL = "https://orientaloutsourcing.in/pizzeria/backend/";

// Live URL
// export const API_URL = "http://localhost:5000"
